<div class="ipm-sale-countdown" *ngIf="label"
    [class.ipm-sale-countdown--inline]="appearance === 'inline'">
    <span class="ipm-countdown-label">⏱ {{label}}</span>
    <!-- inline: the time on one line, e.g. 09d 15h 27m 32s -->
    <span class="ipm-countdown-inline" *ngIf="appearance === 'inline'; else countdownUnits">
        <span class="ipm-countdown-inline-part" *ngFor="let part of parts">
            <span class="ipm-countdown-inline-value">{{part.value}}</span><span class="ipm-countdown-inline-unit">{{part.label.charAt(0).toLowerCase()}}</span>
        </span>
    </span>
    <ng-template #countdownUnits>
        <div class="ipm-countdown-units">
            <ng-container *ngFor="let part of parts; let last = last">
                <div class="ipm-countdown-unit">
                    <span class="ipm-countdown-value">{{part.value}}</span>
                    <span class="ipm-countdown-name">{{part.label}}</span>
                </div>
                <span class="ipm-countdown-sep" *ngIf="!last">:</span>
            </ng-container>
        </div>
    </ng-template>
    <div class="ipm-countdown-dates" *ngIf="enrollmentStartAt">
        <div class="ipm-countdown-date">
            <span class="ipm-date-key">Sale Period</span>
            <span class="ipm-date-value">{{enrollmentStartAt | date : 'd MMM'}} – {{endAt | date : 'd MMM y'}}</span>
        </div>
        <!-- <div class="ipm-countdown-date" *ngIf="startAt">
            <span class="ipm-date-key">Sale</span>
            <span class="ipm-date-value">{{startAt | date : 'd MMM, h:mm a'}} – {{endAt | date : 'd MMM, h:mm a'}}</span>
        </div> -->
    </div>
</div>
